"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TemplatesEntity_1 = __importDefault(require("./Entity/TemplatesEntity"));
var TemplatesApi = /** @class */ (function () {
    function TemplatesApi(session) {
        this.templatesEntity = new TemplatesEntity_1.default(session);
    }
    TemplatesApi.prototype.printZPLPDF = function (body) {
        return this.templatesEntity.printZPLPDF(body);
    };
    TemplatesApi.prototype.getAllTemplates = function () {
        return this.templatesEntity.getAllTemplates();
    };
    TemplatesApi.prototype.getTemplateById = function (id) {
        return this.templatesEntity.getTemplateById(id);
    };
    TemplatesApi.prototype.createTemplate = function (payload) {
        return this.templatesEntity.createTemplate(payload);
    };
    TemplatesApi.prototype.updateTemplate = function (id, payload) {
        return this.templatesEntity.updateTemplate(id, payload);
    };
    TemplatesApi.prototype.deleteTemplate = function (id) {
        return this.templatesEntity.deleteTemplateById(id);
    };
    TemplatesApi.prototype.sendTestEmail = function (payload) {
        return this.templatesEntity.sendTestEmail(payload);
    };
    return TemplatesApi;
}());
exports.default = TemplatesApi;
//# sourceMappingURL=TemplatesApi.js.map